import { makeStyles } from '@rbx/ui';

const useReferenceMemberStyles = makeStyles()((theme) => ({
  tags: {
    display: 'inline-block',
    fontSize: 14,
    [theme.breakpoints.down('XLarge')]: {
      maxWidth: 'initial',
    },
    [theme.breakpoints.down('Large')]: {
      maxWidth: '40vw',
    },
    [theme.breakpoints.down('Medium')]: {
      maxWidth: 'initial',
      marginTop: theme.spacing(1),
    },
  },
}));

export default useReferenceMemberStyles;
